import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getEditaSenha = async (alteraSenhaRequestDTO: {}): Promise<
  { info: string } | { message: string }
> => {
  try {
    const result = await apiService.put(
      'central/usuario/altera-senha',
      alteraSenhaRequestDTO
    )
    if (result.status === 200) {
      return { info: 'Senha alterada com sucesso' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getEditUserLogado = async (usuarioEditRequestDTO: {}): Promise<
  { info: string } | { message: string }
> => {
  try {
    const result = await apiService.put('/central/usuario/me', {
      ...usuarioEditRequestDTO,
    })
    if (result.status === 200) {
      return { info: 'Usuário editado com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
